export default __webpack_public_path__ + "static/media/round-arrow.244e687a.svg";